import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

import { Provider as AlertProvider } from 'react-alert'
import AlertTemplate from './components/common/popups/AlertTemplate'
import { appId, safariWebId } from './config/settings'

const options = {
  position: 'top right',
  timeout: 5000,
  offset: '30px',
  transition: 'scale'
}

var OneSignal = window.OneSignal || []
// OneSignal.log.setLevel('warn');

class Root extends Component {
  componentDidMount () {
    OneSignal.push(function () {
      OneSignal.init({
        appId: appId,
        safari_web_id: safariWebId,
        autoRegister: true,
        notifyButton: {
          enable: false
        }
      })
    })
  }
  render () {
    return (
      <AlertProvider template={AlertTemplate} {...options}>
        <App />
      </AlertProvider>
    )
  }
}

ReactDOM.render(<Root />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js